import { en } from "./en";
import { ru } from "./ru";

export const lang = {
    ru: ru,
    en: en,
};